import React, { useState } from "react";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { FruitifySchoolClassSearch } from "../components/FruitifySchoolClassSearch";
import { Button, Stack, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import { CreateClassDialog } from "../components/CreateClassDialog";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthenticationStore } from "../../../stores/auth";
import { withPageTracking } from "../../../services/postHog";
import {
  checkHasApprovedSubscription,
  checkUserHasRole,
} from "../../auth/Utils";

function ClassOverviewContent({
  schoolId = null,
  showToggle = false,
  onClassViewClicked = () => {},
}) {
  const [open, setOpen] = useState(false);
  const hasApprovedSubscription = checkHasApprovedSubscription();

  const navigate = useNavigate();
  const { user } = useAuthenticationStore();
  return (
    <FruitifyContainer>
      <CreateClassDialog
        open={open}
        setOpen={setOpen}
        onCreate={(schoolClass) => navigate(`view/${schoolClass.id}`)}
      />
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Typography variant="h3">Class information</Typography>

        {(checkUserHasRole({ user, role: "admin" }) ||
          !hasApprovedSubscription) && (
          <Button
            startIcon={<Add />}
            variant="contained"
            onClick={() => setOpen(true)}
          >
            Add class
          </Button>
        )}
      </Stack>

      <FruitifySchoolClassSearch
        schoolId={schoolId}
        onClassViewClicked={onClassViewClicked}
        showToggle={showToggle}
      />
    </FruitifyContainer>
  );
}

const ClassOverview = () => {
  const navigate = useNavigate();
  return (
    <ClassOverviewContent
      showToggle
      onClassViewClicked={(schoolClass) => navigate(`view/${schoolClass.id}`)}
    />
  );
};

const SchoolGroupClassOverview = () => {
  const navigate = useNavigate();
  const { schoolId } = useParams();
  return (
    <ClassOverviewContent
      schoolId={schoolId}
      onClassViewClicked={(schoolClass) =>
        navigate(`/school/classes/view/${schoolClass.id}`)
      }
    />
  );
};

export { SchoolGroupClassOverview };
export default withPageTracking(ClassOverview, { feature: "class-overview" });
